import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { StoreLayout } from "./StoreLayout";

export default function NotFound() {
  return (
    <StoreLayout>
      <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="not-found-page">
        <Compass className="mx-auto text-[var(--brand-link)]" size={40} />
        <h1 className="rs-h1 mt-4 text-[var(--brand-primary)]" data-testid="not-found-title">Page not found</h1>
        <p className="text-slate-500 mt-2">The page you’re looking for doesn’t exist or may have moved.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/" data-testid="not-found-home" className="bg-[var(--brand-primary)] text-white rounded-full px-6 py-2.5 text-sm font-semibold">Back to home</Link>
          <Link to="/account" data-testid="not-found-account" className="border border-slate-300 rounded-full px-6 py-2.5 text-sm font-semibold text-[var(--brand-primary)]">My account</Link>
        </div>
      </div>
    </StoreLayout>
  );
}
